<template>
<section class="input-container">
    <div class="label">
        <p><i class="icon-required" v-if="transProp.validations.presence === '1'">*</i>{{transProp.label}}:</p>
        <van-icon name="question-o" class="question" v-if="transProp.notes" @click="showNotes" />
    </div>
    <div class="inp-f" @click="showSelect">
        <input type="text" class="inp-s" v-model="value" @input="validate" disabled>
        <van-icon name="calender-o" class="arrow-down" />
    </div>
    <div class="form-error" v-show="showError">
        {{transProp.label}}不可为空
    </div>
    <van-datetime-picker
  v-model="currentDate"
  type="date"
  :min-date="minDate"
  v-if="show" @confirm="confirm" @cancel="cancel"
/>
    <!-- <van-calendar 
    v-model="show" 
    @confirm="onConfirm" 
  :default-date="defaultDate"
    /> -->
</section>
</template>

<script>
import { DatetimePicker, Icon } from "vant";
export default {
  props: {
    transProp: Object,
    index: Number
  },
  components: {
    // "van-calendar": Calendar,
    "van-icon": Icon,
    "van-datetime-picker": DatetimePicker,
  },
  data() {
    return {
      show: false,
      value: "",
      showError: false,
      currentDate: new Date(),
      minDate: new Date(1970, 0, 1),
      // maxDate: new Date(2025, 10, 1),
      actions: [
        {
          name: "选项2"
        },
        {
          name: "选项1"
        },
        {
          name: "选项3",
          subname: "描述信息"
        }
      ]
    };
  },
  methods: {
    showNotes() {
      this.$emit("input", this.index);
    },
    confirm(date) {
      this.value = this.setDate(date);
      this.show = false;
      this.validate();
    },
    setDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      return `${year}-${month + 1}-${day}`;
    },
    cancel(params) {
      this.show = false;
      // console.log(params)
    },
    collectOptions() {
      let options = {
        code: this.transProp.code,
        value: this.value
      };
      return options;
    },
    // formatDate(date) {
    //   return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    // },
    // onConfirm(date) {
    //   this.show = false;
    //   this.value = this.formatDate(date);
    //   this.validate();
    // },
    showSelect(item) {
      this.show = true;
    },
    validate() {
      if (this.transProp.required) {
        if (!this.value) {
          this.showError = true;
          return { label: this.transProp.label, boo: true };
        } else {
          this.showError = false;
          return { label: this.transProp.label, boo: false };
        }
      } else {
        return { label: this.transProp.label, boo: false };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.input-container {
  .inp-f {
    margin: 8px 0;
    position: relative;

    .inp-s {
      color: #999090;
    }

    .arrow-down {
      font-size: 40px;
      color: #999090;
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .label {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .question {
      color: #999090;
      font-size: 32px;
    }
  }
}
</style>
